<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
  <app-dropdown
    class="input w-full md:w-[25%]"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['groupType']"
    [options]="groupsTypeFilter"
    controlName="groupType"
    label="Group Type"
    placeholder="Select one"
    type="small"
    [loading]="groupsTypeLoading"
    [enableMultiple]="true"
    [enableClearSelection]="true"
  />
  <app-dropdown
    class="input w-full md:w-[25%]"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['groupStatus']"
    [options]="groupsStatusFilter"
    controlName="groupStatus"
    label="Group Status"
    placeholder="Select one"
    type="small"
    [loading]="groupsStatusLoading"
    [enableMultiple]="true"
    [enableClearSelection]="true"
  />

  <hr class="vertical hidden md:block">

  <app-text-input
    class="input w-full md:w-[30%] search-input"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['search']"
    suffixIcon="search"
    controlName="search"
    label="Search"
    placeholder="Search Group"
    type="small"
    [minLength]="1"
    (handleSuffixClick)="apply()"
  ></app-text-input>

  <hr class="vertical hidden md:block">

  <app-primary-button
    type="small"
    class="btn w-full md:w-[10%]"
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
  >
    Apply
  </app-primary-button>

</div>
